import { NewsItem } from '../api/adserver';

const getTopImageUrl = (news: NewsItem) => {
  let topImageUrl = null;
  if (news.gallery && news.gallery.length > 0) {
    topImageUrl = news.gallery[0].url;
  }
  return topImageUrl;
};

export { getTopImageUrl };
